import React, { useEffect, useState } from "react";
import Config from "../Config";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../useAuthhandling';
import Deletemodal from "../Deletemodal";
import Nodatafound from "../Nodatafound";

function Adslist() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }


  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [adsdata, setAdsdata] = useState([]);

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/ad/get-ads`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200 ) {
      const data = await res.json();

      setAdsdata(data.data);
    }
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/ad/delete-ad/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200 ) {
      const deletedata = await response.json();

      toast.success(" adds deleted", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      getinfo();
    } 
    
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }

  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Ads List</h4>
                    <div className="table-responsive pt-3">

                      {adsdata?.length>0?
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sl.No</th>
                            <th>Title</th>
                            <th>Link</th>
                            <th>Image</th>

                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {adsdata.map((element, i) => {
                            return (
                              <>
                                <tr>
                                  <th scope="row">{i + 1}</th>
                                  <td>{element.adTitle}</td>
                                  <td>{element.link}</td>

                                  <td>
                                    <img
                                      src={element.adImage}
                                      width="50"
                                      alt=""
                                    />
                                  </td>
                                  <td className="actions_td">
                                    <Link
                                      // onClick={() => deleteads(element._id)}
                                      onClick={() => tog_animationFlip(element._id)}
                                      className="margins-2"
                                    >
                                      <i className="fa-solid fa-trash action_icons" />
                                    </Link>
                                   
                                      <Link
                                        to={"/editad/" + element._id}
                                        className="fa-solid fa-pen action_icons"
                                       
                                      ></Link>

                                      <Link
                                        to={"/adsview/" + element._id}
                                        className=" action_icons"                                       
                                      >
                                          <i className="fa-solid fa-eye" />
                                        </Link>      
                                   
                                    <ToastContainer />
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                      :
                      <Nodatafound/>
                        }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Ad"}
          />
        ) : (
          ""
        )}
    </div>
  );
}

export default Adslist;
